import type { EEnrollmentStatusEnum } from '@/shared/api/generated';
import type { EnrollmentStatus } from './enrollment';

export const ENROLLMENT_STATUS_TO_CODE: Record<EnrollmentStatus, EEnrollmentStatusEnum> = {
  payment_selection: 1,
  payment_pending: 2,
  approval_pending: 3,
  approved: 4,
  activating: 5,
  active: 6,
  transferred: 7,
  transferred_in_registration: 8,
  canceled: 9,
  canceled_in_registration: 10,
  rejected: 11,
  finished_with_pendencies: 12,
  finished: 13,
  finished_with_monograph: 14,
  finished_with_certificate: 15,
  blocked: 16,
};

export const ENROLLMENT_CODE_TO_STATUS: Record<number, EnrollmentStatus> = Object.fromEntries(
  Object.entries(ENROLLMENT_STATUS_TO_CODE).map(([k, v]) => [v, k]),
) as Record<number, EnrollmentStatus>;
